import React, { useState } from "react";
import { httpPost } from "../../components/helpers/httpMethods";
import AppLogo from "../../assets/images/appLogoV2.png";
import "./authPages.css";

const MailIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M3 7l9 6 9-6" />
  </svg>
);

export default function ForgotPassword({ history, location }) {
  const initial =
    new URLSearchParams((location && location.search) || window.location.search).get("email") || "";
  const [email, setEmail] = useState(initial);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [sentTo, setSentTo] = useState("");

  const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  const goLogin = () => history.push("/login");

  const send = async (e) => {
    if (e) e.preventDefault();
    if (!valid || busy) return;
    setBusy(true);
    setError("");
    const res = await httpPost("auth/user/forgot_password", { email: email.trim() });
    setBusy(false);
    if (!res || res.er) {
      setError((res && res.er && (res.er.message || String(res.er))) || "Something went wrong. Please try again.");
      return;
    }
    setSentTo(email.trim());
  };

  return (
    <main className="ap-page">
      <div className="ap-card">
        <button type="button" className="ap-logo" onClick={() => history.push("/")} aria-label="TheNewspaperStand home">
          <img src={AppLogo} alt="TheNewspaperStand" />
        </button>

        {sentTo ? (
          <>
            <span className="ap-icon"><MailIcon /></span>
            <h1 className="ap-title">Check your email</h1>
            <p className="ap-sub">
              If an account exists for <strong>{sentTo}</strong>, we’ve sent a link to reset your password. It works for 1 hour. Check your spam folder if it doesn’t arrive in a few minutes.
            </p>
            {error ? <p className="ap-error" role="alert">{error}</p> : null}
            <button type="button" className="ap-btn ap-btn-outline" onClick={send} disabled={busy}>
              {busy ? "Sending…" : "Resend link"}
            </button>
            <p className="ap-footer">
              <button type="button" className="ap-link" onClick={() => setSentTo("")}>Use a different email</button>
              <span aria-hidden="true">·</span>
              <button type="button" className="ap-link" onClick={goLogin}>Back to log in</button>
            </p>
          </>
        ) : (
          <form className="ap-form" onSubmit={send} noValidate>
            <h1 className="ap-title">Forgot your password?</h1>
            <p className="ap-sub">Enter the email you use for TNS and we’ll send you a link to set a new one.</p>
            <div className="ap-field">
              <label className="ap-label" htmlFor="ap-email">Email address</label>
              <div className="ap-input-wrap">
                <input
                  id="ap-email"
                  className="ap-input"
                  type="email"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoFocus
                />
              </div>
            </div>
            {error ? <p className="ap-error" role="alert">{error}</p> : null}
            <button type="submit" className="ap-btn" disabled={!valid || busy}>
              {busy ? "Sending…" : "Send reset link"}
            </button>
            <p className="ap-footer">
              Remembered it? <button type="button" className="ap-link" onClick={goLogin}>Log in</button>
            </p>
          </form>
        )}
      </div>
    </main>
  );
}
